"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HELP_CENTER = void 0;
exports.HELP_CENTER = 'https://digitalsupport.greatminds.org/s/';
